// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useStripeClui} from '../helpers/react/provider';
import StripeCluiButtonLink from './ButtonLink';

type Props = {};

const stripeAsciiArt = `     _         __
 ___| |_ _ __ /_/ __   ___
/ __| __| '__| | '_ \\ / _ \\
\\__ \\ |_| |  | | |_) |  __/
|___/\\__|_|  |_| .__/ \\___|
               |_|
`;

const messages = defineMessages({
  welcome: {
    id: 'docsApp.clui.welcome',
    description:
      'Message that appears when the user opens the Stripe Shell (fka Stripe CLUI).',
    defaultMessage: `
Welcome to the Stripe Shell!

This is a graphical user interface of the Stripe CLI. You can use it to discover
webhook events and manage your Stripe resources. By pressing ctrl + \` you can
toggle it open from any page within the Stripe documentation.

- View supported commands: {Command1Link}
- Listen for webhook events: {Command2Link}
- Trigger webhook events: {Command3Link}
- Call Stripe APIs: stripe [api resource] [api operation] (e.g. {Command4Link})
`,
  },
});

const WelcomePrompt = (props: Props): React.Node => {
  const {
    invokeCommand,
    state: {panes},
    updatePane,
  } = useStripeClui();
  return (
    <pre>
      <code className="CodeBlock">
        <div>{stripeAsciiArt}</div>
        <div>
          <FormattedMessage
            {...messages.welcome}
            values={{
              Command1Link: (
                <StripeCluiButtonLink
                  label={<code>{'stripe help ▶️'}</code>}
                  onClick={(e) => {
                    invokeCommand({
                      command: 'stripe help',
                      paneIdx: 0,
                    });
                  }}
                />
              ),
              Command2Link: (
                <StripeCluiButtonLink
                  label={<code>{'stripe listen ▶'}</code>}
                  onClick={(e) => {
                    e.stopPropagation();
                    const newPaneIdx = panes.length;
                    invokeCommand({
                      command: 'stripe listen',
                      paneIdx: newPaneIdx,
                    });
                  }}
                />
              ),
              Command3Link: (
                <StripeCluiButtonLink
                  label={<code>{'stripe trigger ▶️ [event]'}</code>}
                  onClick={(e) => {
                    const command = 'stripe trigger '; // trailing space to get suggestions to appear
                    const cursorIndex = command.length;
                    updatePane({paneIdx: 0, pane: {command, cursorIndex}});
                  }}
                />
              ),
              Command4Link: (
                <StripeCluiButtonLink
                  label={<code>{'stripe customers list ▶️'}</code>}
                  onClick={(e) => {
                    invokeCommand({
                      command: 'stripe customers list',
                      paneIdx: 0,
                    });
                  }}
                />
              ),
            }}
          />
        </div>
      </code>
    </pre>
  );
};

export default WelcomePrompt;
